import { render } from "./Method.vue?vue&type=template&id=11bd3f56&scoped=true&ts=true"
import script from "./Method.vue?vue&type=script&lang=ts"
export * from "./Method.vue?vue&type=script&lang=ts"

import "./Method.vue?vue&type=style&index=0&id=11bd3f56&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bd3f56"]])

export default __exports__